<sharry-header></sharry-header>
@if (land$ | async; as land) {
  @if ({ myFollow: myFollow$ | async }; as context) {
    <div class="land">
      <!-- SUB HEADER -->
      <div
        class="land__share-actions"
        [class.land__share-actions--intersecting]="headerIntersecting">
        <sharry-entity-title
          class="is-not-mobile"
          [class.hidden]="headerIntersecting"
          [content]="$any(land)"
          [entityTitle]="land.title"></sharry-entity-title>
        <p
          class="bigger semibold is-mobile"
          sharryEllipsisTooltip="1"
          [class.hidden]="headerIntersecting">
          {{ land.title }}
        </p>
        <button
          class="sharry-medium is-not-mobile"
          mat-stroked-button
          [color]="context.myFollow ? 'primary' : 'secondary'"
          [disabled]="onFollowBusy"
          (click)="!onFollowBusy && onFollow(land)">
          <sharry-icon
            matIconPrefix
            type="custom"
            [name]="context.myFollow ? 'land-follow-active' : 'land-follow'"></sharry-icon>
          {{ (context.myFollow ? 'land.unfollow' : 'land.follow') | i18next }}
        </button>
        <button
          color="secondary"
          class="sharry-medium is-not-mobile"
          mat-stroked-button
          (click)="onShare(land)">
          <sharry-icon
            matIconPrefix
            registryName="share-network"></sharry-icon>
          {{ 'land.header.share' | i18next }}
        </button>
        <button
          class="sharry-small is-mobile"
          mat-icon-button
          [class.bordered]="headerIntersecting"
          [color]="context.myFollow ? 'primary' : 'secondary'"
          [disabled]="onFollowBusy"
          (click)="!onFollowBusy && onFollow(land)">
          <sharry-icon
            type="custom"
            [name]="context.myFollow ? 'land-follow-active' : 'land-follow'"></sharry-icon>
        </button>
        <button
          color="secondary"
          class="sharry-small is-mobile"
          mat-icon-button
          [class.bordered]="headerIntersecting"
          (click)="onShare(land)">
          <sharry-icon registryName="share-network"></sharry-icon>
        </button>
      </div>
      <!-- HERO -->
      <div class="land__hero">
        <sharry-hero
          [backGroundImages]="backGroundImages"
          [resolutions]="resolutions"
          [component]="'land'"
          [fullHero]="true"
          [thumb]="thumb"
          [animate]="true"
          [interval]="6000"></sharry-hero>
        <div class="land__overlay">
          <section class="land__overlay__icon">
            <picture [ngClass]="{ 'land__no-icon': land.image }">
              @if (land.image?.url) {
                <source
                  media="(max-width: 767px)"
                  [srcset]="land.image?.vw768" />
                <img
                  height="120"
                  width="120"
                  loading="eager"
                  fetchpriority="high"
                  alt="icona"
                  [src]="land.image?.url" />
              }
            </picture>
          </section>

          <h1>{{ land.title }}</h1>
          <div class="land__overlay__actions">
            <button
              color="secondary"
              class="sharry-big land__overlay__gallery"
              mat-icon-button
              (click)="onShowGalleryChange(land)">
              <sharry-icon name="image-square"></sharry-icon>
            </button>
            @if (land.video) {
              <button
                color="primary"
                class="sharry-big sharry-inverted"
                mat-icon-button
                (click)="onClickVideo(land.video)">
                <sharry-icon
                  name="play-fill"
                  type="custom"></sharry-icon>
              </button>
            }
          </div>
        </div>
      </div>
      <!-- DESCRIPTION -->
      <div class="land__description">
        <div>
          <sharry-categories [categories]="land.categories"></sharry-categories>
          <h2>{{ land.subtitle }}</h2>
          <sharry-expandable-paragraph
            paragraphClass="markdown"
            [content]="land.description"
            [maxWords]="250"
            [showLessLabel]="'sharry.show-less' | i18next"
            [showMoreLabel]="'sharry.show-more' | i18next"></sharry-expandable-paragraph>

          <sharry-land-followers
            [slug]="land?.slug"
            [myFavourite]="meAsFollower">
          </sharry-land-followers>
        </div>
        <picture>
          <img
            loading="lazy"
            alt="Mappa del Land"
            [src]="'https://media.sharry.land/app/land/' + land.slug + '/italy.webp'" />
        </picture>
      </div>
      <!-- POST -->
      @if (land.postList.length) {
        @if (postList$ | async; as postList) {
          <div class="land__post">
            <h2>{{ 'land.carousel.community' | i18next }}</h2>
            @if (postList?.length) {
              <sharry-card-carousel
                [contents]="postList"
                [mode]="'template'"
                [itemTemplate]="postTemplate"
                [usePagination]="true"
                [grid]="{ xs: 1, sm: 1, md: 3, lg: 4, xl: 4 }"
                [subtitle]="
                  '<strong>' + ('land.carousel-buttons.results' | i18next) + ': ' + postList.length + '</strong>'
                ">
                <ng-template
                  #postTemplate
                  let-item>
                  <sharry-post-card [post]="item"></sharry-post-card>
                </ng-template>
              </sharry-card-carousel>
            }
          </div>
        }
      }
      <!-- CALENDAR -->
      @if (land.calendarList.length) {
        @if (calendarList$ | async; as calendarList) {
          <ng-container
            [ngTemplateOutlet]="carousel"
            [ngTemplateOutletContext]="{
              title: 'land.carousel.calendar',
              type: 'calendar',
              filters: calendarFilters,
              list: calendarList,
              key: currentCalendarKey,
              busy: calendarBusy,
            }"></ng-container>
        }
      }
      <!-- ADV -->
      @if (land.visibleAdvertisements.length > 1) {
        @if (advList[1] | async; as adv) {
          @if (adv) {
            <sharry-adv-banner [advertisements]="[adv]"></sharry-adv-banner>
          }
        }
      }
      <!-- FEATURED -->
      @if (land.featuredList.length) {
        @if (featuredList$ | async; as featuredList) {
          <ng-container
            [ngTemplateOutlet]="carousel"
            [ngTemplateOutletContext]="{
              title: 'land.carousel.featured',
              type: 'featured',
              filters: featuredFilters,
              list: featuredList,
              key: currentFeaturedKey,
              busy: featuredBusy,
            }"></ng-container>
        }
      }
      <!-- ADV -->
      @if (land.visibleAdvertisements.length > 0) {
        @if (advList[0] | async; as adv) {
          @if (adv) {
            <sharry-adv-banner [advertisements]="[adv]"></sharry-adv-banner>
          }
        }
      }
      <!-- USERS -->
      @if (land.userGoldList.length) {
        @if (userGoldList$ | async; as userGoldList) {
          <ng-container
            [ngTemplateOutlet]="carousel"
            [ngTemplateOutletContext]="{
              title: 'land.carousel.userGold',
              type: 'userGold',
              filters: userGoldFilters,
              list: userGoldList,
              key: currentUserGoldKey,
              busy: userGoldBusy,
            }"></ng-container>
        }
      }
      <!-- ADV -->
      @if (land.visibleAdvertisements.length > 2) {
        @if (advList[2] | async; as adv) {
          @if (adv) {
            <sharry-adv-banner [advertisements]="[adv]"></sharry-adv-banner>
          }
        }
      }
      <!-- MAPPA -->
      <div class="land__map">
        <h2 class="land__map__title">{{ 'land.map.map' | i18next }}&nbsp;{{ land.name }}</h2>
        <h4 class="land__map__subtitle">{{ 'land.map.subtitle' | i18next }}</h4>
        <picture
          role="button"
          (click)="onMapClick(land)">
          <img
            loading="lazy"
            alt="Mappa del Land"
            [src]="'https://media.sharry.land/app/land/' + land.slug + '/map.webp'" />
        </picture>
      </div>
      <!-- USEFUL INFO -->
      <div class="land__info">
        <h2 class="land__info__tile">{{ 'land.useful.useful-to-know' | i18next }}</h2>
        <div class="land__info__filters">
          @for (
            filter of ['howReach', 'weatherTitle', 'specialDays', 'ideal', 'accessibility', 'contacts']
              | filter
                : {
                    howReach: land.howReach,
                    accessibility: land.accessibility,
                    ideal: land.ideal,
                    specialDays: land.specialDays,
                    contacts: land.contacts,
                  };
            track filter
          ) {
            <button
              style="flex: none"
              type="button"
              mat-stroked-button
              class="rounded sharry-medium"
              [color]="filter === currentUsefulKey ? 'primary' : 'secondary'"
              (click)="onUsefulFilterClick(filter)">
              {{ 'land.' + filter | i18next | titlecase }}
            </button>
          }
        </div>
        @if (currentUsefulKey === 'weatherTitle') {
          <sharry-weather [centerCoordinates]="land.centerCoordinates"></sharry-weather>
        } @else {
          <div class="land__info__table">
            @for (n of $any(land)[currentUsefulKey]; track n) {
              <p class="bigger bold">{{ n.title }}</p>
              <p
                class="bigger"
                [innerHTML]="n.description ?? '' | safe: 'html'"></p>
            }
          </div>
        }
      </div>
      <!-- THANKS GIVEN -->
      @if (land.collaborationUrls.length) {
        <div class="land__thanks-given">
          <h3>{{ ('land.collab.land' | i18next) + ' ' + land.name + ' ' + ('land.collab.collab' | i18next) }}</h3>
          <div class="land__collaborations">
            @for (collaboration of land.collaborations; track collaboration.id) {
              <div class="land__collaborations__collaboration cursor-pointer">
                <a
                  [routerLink]="collaboration.user | slug"
                  [avatar]="{ user: collaboration?.user, size: 'small', imgSize: '82px' }">
                </a>
                <p
                  class="land__collaborations__collaboration__caption"
                  role="button"
                  [routerLink]="collaboration.user | slug">
                  {{ collaboration?.user | userName }}
                </p>
              </div>
            }
          </div>
          <h4>{{ 'land.collab.thanks' | i18next }}</h4>
          <div class="land__collaborations">
            @for (url of land.collaborationUrls; track url; let i = $index) {
              <a
                target="_blank"
                [href]="url.redirectUrl"
                ><img
                  height="56"
                  width="170"
                  [src]="url.imageUrl"
                  [alt]="'ringraziamento-' + i"
              /></a>
            }
          </div>
        </div>
      }
    </div>
  }
} @else {
  <sharry-loading [fullscreen]="true"></sharry-loading>
}

<sharry-footer class="is-not-mobile"></sharry-footer>

<ng-template
  #carousel
  let-title="title"
  let-type="type"
  let-filters="filters"
  let-list="list"
  let-key="key"
  let-busy="busy"
  [typeToken]="typeToken">
  <div [class]="'land__' + type">
    <h2>{{ title | i18next }}</h2>
    <div class="land__filters">
      @for (filter of filters; track $index) {
        <button
          style="flex: none"
          type="button"
          mat-stroked-button
          class="rounded sharry-medium"
          [color]="filter.key === key ? 'primary' : 'secondary'"
          (click)="onFilterClick(filter.key, type)">
          {{ filter.value | i18next | titlecase }}{{ filter.displayCount ? ' (' + filter.count + ')' : '' }}
        </button>
      }
    </div>
    @if ({ count: filters | activeFilterCount: key }; as carouselContext) {
      @if (list?.length && !busy()) {
        <sharry-card-carousel
          [contents]="list"
          [subtitle]="
            '<strong>' + ('land.carousel-buttons.results' | i18next) + ': ' + carouselContext.count + '</strong>'
          "
          [usePagination]="true"
          [total]="carouselContext.count"
          (carouselWheel)="onWheel(type, carouselContext.count)"
          (next)="onNext(type, carouselContext.count)"></sharry-card-carousel>
      } @else {
        <section class="land__carousel-busy">
          <sharry-loading></sharry-loading>
        </section>
      }
    }
  </div>
</ng-template>
